import { Props } from "../SelectMenu";
import { CheckboxSelectMenuItem } from "~/components/Form/components/SelectMenu/CheckboxSelectMenuItem";
import { BaseSelectMenuGroup } from "~/components/Form/components/SelectMenu/BaseSelectMenu/BaseSelectMenuGroup";
import { PlainSelectMenuItem } from "~/components/Form/components/SelectMenu/PlainSelectMenuItem";
import { isGroupedOptions } from "~/components/Form/components/SelectMenu/utils/selectMenuUtils";
import {
  BASE_MEMBERS_ROLES,
  MemberRoleGroupLabel,
} from "~/components/Members/const";

export function useSelectMenu(props: Props) {
  const { options, value, onChange } = props;

  const handleChange = (optionValue: string) => {
    if (Array.isArray(value)) {
      const isOptionSelected = value.includes(optionValue);

      if (isOptionSelected) {
        let newValue = value.filter((v) => v !== optionValue);
        onChange(newValue);
      } else {
        onChange([...value, optionValue]);
      }
    } else {
      const isOptionSelected = value === optionValue;
      onChange(isOptionSelected ? "" : optionValue);
    }
  };

  function renderMenuItems() {
    switch (props.variant) {
      case "checkbox":
        if (isGroupedOptions(options)) {
          // Determine if any base role group is selected
          const hasAnyBaseRoleSelected = Array.isArray(value)
            ? BASE_MEMBERS_ROLES.some((opt) => value.includes(opt.value))
            : false;

          return options.map((group, index) => (
            <BaseSelectMenuGroup groupTitle={group.groupLabel} key={index}>
              {group.options.map((option) => (
                <CheckboxSelectMenuItem
                  label={option.label}
                  value={option.value}
                  isChecked={value.includes(option.value)}
                  key={option.value}
                  onClick={handleChange}
                  disabled={
                    // Disable items in the "Detailed Permissions" group until a base role is selected
                    group.groupLabel.toLowerCase() ===
                      MemberRoleGroupLabel.Detailed && !hasAnyBaseRoleSelected
                  }
                />
              ))}
            </BaseSelectMenuGroup>
          ));
        }

        return options.map((option) => (
          <CheckboxSelectMenuItem
            label={option.label}
            value={option.value}
            isChecked={value.includes(option.value)}
            key={option.value}
            onClick={handleChange}
          />
        ));
      case "plain":
      default:
        if (isGroupedOptions(options)) {
          return options.map((group, index) => (
            <BaseSelectMenuGroup groupTitle={group.groupLabel} key={index}>
              {group.options.map((option) => (
                <PlainSelectMenuItem
                  key={option.value}
                  label={option.label}
                  value={option.value}
                  onClick={handleChange}
                  isSelected={value.includes(option.value)}
                />
              ))}
            </BaseSelectMenuGroup>
          ));
        }

        return options.map((option) => (
          <PlainSelectMenuItem
            key={option.value}
            label={option.label}
            value={option.value}
            onClick={handleChange}
            isSelected={value.includes(option.value)}
          />
        ));
    }
  }

  return { renderMenuItems };
}
